module.exports = __webpack_public_path__ + "static/21-03-29_13-51-39_4821-def74a509ab9c6ab2cca34a49b10f2fc.jpg";